import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'

const MetaDescription = (props) => {
	if (props.description) {
		const value = props.description

		return (
			<Helmet>
				<meta name="description" content={value} />
			</Helmet>
		)
	}

	return null
}

MetaDescription.propTypes = {
	description: PropTypes.string,
}

export default MetaDescription


// WEBPACK FOOTER //
// ./src/common/components/meta/meta-description.js